<template>
  <span>
    <v-card>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-title primary-title>
                <div class="headline">Wachtlijst</div>
              </v-card-title>
              <v-data-table
                v-if="$vuetify.breakpoint.xs"
                :headers="headersWaiting"
                :items="flights | onlyWaiting"
                :search="search"
                hide-actions
                default-sort="StartTime:desc"
                must-sort
                no-data-text="Geen vluchten in de wachtlijst"
              >
                <template slot="headers">
                  <th class="text-xs-left">
                    <div>Gezagvoerder</div>
                    <div>Tweede inzittende</div>
                  </th>
                  <th class="text-xs-left">
                    <div>Toestel</div>
                  </th>
                </template>

                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item[1].commander.name }}
                    <div
                      class="text-xs-left"
                      v-if="props.item[1].passenger !== undefined"
                    >
                      {{ props.item[1].passenger.name }}
                    </div>
                    <div class="text-xs-left" v-else></div>
                  </td>

                  <td class="text-xs-left">
                    {{ planeToString(props.item[1].plane) }}
                  </td>
                </template>
              </v-data-table>

              <v-data-table
                v-else
                :headers="headersWaiting"
                :items="flights | onlyWaiting"
                :search="search"
                hide-actions
                default-sort="StartTime:desc"
                must-sort
                no-data-text="Geen vluchten in de wachtlijst"
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item[1].commander.name }}
                  </td>

                  <td
                    class="text-xs-left"
                    v-if="props.item[1].passenger !== undefined"
                  >
                    {{ props.item[1].passenger.name }}
                  </td>
                  <td class="text-xs-left" v-else></td>

                  <td class="text-xs-left">
                    {{ planeToString(props.item[1].plane) }}
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card>
              <v-card-title primary-title>
                <div class="headline">In de lucht</div>
              </v-card-title>

              <v-data-table
                v-if="$vuetify.breakpoint.xs"
                :headers="headers"
                :items="flights | onlyFlying"
                :search="search"
                hide-actions
                default-sort="StartTime:desc"
                must-sort
                no-data-text="Geen vluchten in de lucht"
              >
                <template slot="headers">
                  <th class="text-xs-left">
                    <div>Gezagvoerder</div>
                    <div>Tweede inzittende</div>
                  </th>
                  <th class="text-xs-left">
                    <div>Toestel</div>
                  </th>

                  <th class="text-xs-left">
                    <div>Starttijd</div>
                    <div>Vluchtduur</div>
                  </th>
                </template>

                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item[1].commander.name }}
                    <div
                      class="text-xs-left"
                      v-if="props.item[1].passenger !== undefined"
                    >
                      {{ props.item[1].passenger.name }}
                    </div>
                    <div class="text-xs-left" v-else></div>
                  </td>

                  <td
                    class="text-xs-left"
                    v-if="props.item[1].plane.callsign === undefined"
                  >
                    {{ planeToString(props.item[1].plane) }}
                  </td>
                  <td class="text-xs-left" v-else>
                    {{ props.item[1].plane.callsign }}
                    <br />
                    {{ props.item[1].plane.registration }}
                  </td>
                  <td class="text-xs-left">
                    <div v-if="props.item[1].startTime !== undefined">
                      {{ props.item[1].startTime | formatedTime }}
                    </div>
                    <div class="text-xs-left" v-else></div>

                    <div
                      v-if="props.item[1].endTime === undefined"
                      class="text-xs-left red--text font-weight-bold"
                    >
                      {{ duration(props.item[1]) | formatedDuration }}
                    </div>
                    <div v-else class="text-xs-left">
                      {{ duration(props.item[1]) | formatedDuration }}
                    </div>
                  </td>
                </template>
              </v-data-table>

              <v-data-table
                v-else
                :headers="headers"
                :items="flights | onlyFlying"
                :search="search"
                hide-actions
                default-sort="StartTime:desc"
                must-sort
                no-data-text="Geen vluchten in de lucht"
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item[1].commander.name }}
                  </td>

                  <td
                    class="text-xs-left"
                    v-if="props.item[1].passenger !== undefined"
                  >
                    {{ props.item[1].passenger.name }}
                  </td>
                  <td class="text-xs-left" v-else></td>

                  <td class="text-xs-left">
                    {{ planeToString(props.item[1].plane) }}
                  </td>
                  <td
                    class="text-xs-left"
                    v-if="props.item[1].startTime !== undefined"
                  >
                    {{ props.item[1].startTime | formatedTime }}
                  </td>
                  <td class="text-xs-left" v-else></td>

                  <td
                    v-if="props.item[1].endTime === undefined"
                    class="text-xs-left red--text font-weight-bold"
                  >
                    {{ duration(props.item[1]) | formatedDuration }}
                  </td>
                  <td v-else class="text-xs-left">
                    {{ duration(props.item[1]) | formatedDuration }}
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card>
              <v-card-title primary-title>
                <div class="headline">Net geland</div>
              </v-card-title>

              <v-data-table
                v-if="$vuetify.breakpoint.xs"
                :headers="headers"
                :items="justLandedFlights"
                :search="search"
                hide-actions
                default-sort="StartTime:desc"
                must-sort
                no-data-text="Geen vluchten die net geland zijn"
              >
                <template slot="headers">
                  <th class="text-xs-left">
                    <div>Gezagvoerder</div>
                    <div>Tweede inzittende</div>
                  </th>
                  <th class="text-xs-left">
                    <div>Toestel</div>
                  </th>

                  <th class="text-xs-left">
                    <div>Starttijd</div>
                    <div>Vluchtduur</div>
                  </th>
                </template>

                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item[1].commander.name }}
                    <div
                      class="text-xs-left"
                      v-if="props.item[1].passenger !== undefined"
                    >
                      {{ props.item[1].passenger.name }}
                    </div>
                    <div class="text-xs-left" v-else></div>
                  </td>

                  <td
                    class="text-xs-left"
                    v-if="props.item[1].plane.callsign === undefined"
                  >
                    {{ planeToString(props.item[1].plane) }}
                  </td>
                  <td class="text-xs-left" v-else>
                    {{ props.item[1].plane.callsign }}
                    <br />
                    {{ props.item[1].plane.registration }}
                  </td>
                  <td class="text-xs-left">
                    <div v-if="props.item[1].startTime !== undefined">
                      {{ props.item[1].startTime | formatedTime }}
                    </div>
                    <div class="text-xs-left" v-else></div>

                    <div
                      v-if="props.item[1].endTime === undefined"
                      class="text-xs-left red--text font-weight-bold"
                    >
                      {{ duration(props.item[1]) | formatedDuration }}
                    </div>
                    <div v-else class="text-xs-left">
                      {{ duration(props.item[1]) | formatedDuration }}
                    </div>
                  </td>
                </template>
              </v-data-table>

              <v-data-table
                v-else
                :headers="headers"
                :items="justLandedFlights"
                :search="search"
                hide-actions
                default-sort="StartTime:desc"
                must-sort
                no-data-text="Geen vluchten die net geland zijn"
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">
                    {{ props.item[1].commander.name }}
                  </td>

                  <td
                    class="text-xs-left"
                    v-if="props.item[1].passenger !== undefined"
                  >
                    {{ props.item[1].passenger.name }}
                  </td>
                  <td class="text-xs-left" v-else></td>

                  <td class="text-xs-left">
                    {{ planeToString(props.item[1].plane) }}
                  </td>
                  <td
                    class="text-xs-left"
                    v-if="props.item[1].startTime !== undefined"
                  >
                    {{ props.item[1].startTime | formatedTime }}
                  </td>
                  <td class="text-xs-left" v-else></td>

                  <td
                    v-if="props.item[1].endTime === undefined"
                    class="text-xs-left red--text font-weight-bold"
                  >
                    {{ duration(props.item[1]) | formatedDuration }}
                  </td>
                  <td v-else class="text-xs-left">
                    {{ duration(props.item[1]) | formatedDuration }}
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </span>
</template>

<script>
import { db } from "../main";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headersWaiting: [
        {
          text: "Gezagvoerder",
          align: "left",
          sortable: false,
          value: "commander.name"
        },
        {
          text: "Tweede inzittende",
          align: "left",
          sortable: false,
          value: "passenger.name"
        },
        {
          text: "Toestel",
          align: "left",
          sortable: false,
          value: "plane.planeString"
        }
      ],
      headers: [
        {
          text: "Gezagvoerder",
          align: "left",
          sortable: false,
          value: "commander.name"
        },
        {
          text: "Tweede inzittende",
          align: "left",
          sortable: false,
          value: "passenger.name"
        },
        {
          text: "Toestel",
          align: "left",
          sortable: false,
          value: "plane.planeString"
        },
        {
          text: "Starttijd",
          align: "left",
          sortable: true,
          value: "startTime"
        },
        {
          text: "Vluchtduur",
          align: "left",
          sortable: true,
          value: "duration"
        }
      ],
      flights: [],
      interval: null,
      today: null,
      now: null
    };
  },
  filters: {
    formatedTime(value) {
      if (value) {
        return moment(value).format("HH:mm");
      }
    },
    formatedDuration(value) {
      if (value) {
        var duration = moment.duration(value);
        return (
          Math.floor(duration.asMinutes()) +
          ":" +
          moment.utc(duration.asMilliseconds()).format("ss")
        );
      }
    },
    onlyWaiting(value) {
      if (value) {
        return value.filter(
          flight =>
            flight[1].startTime == undefined && flight[1].endTime == undefined
        );
      }
    },
    onlyFlying(value) {
      if (value) {
        return value.filter(
          flight =>
            flight[1].startTime != undefined && flight[1].endTime == undefined
        );
      }
    }
  },
  computed: {
    justLandedFlights: function() {
      return this.$data.flights.filter(
        flight =>
          flight[1].endTime != undefined &&
          this.$data.now - flight[1].endTime < 120000
      );
    }
  },
  methods: {
    duration: function(start) {
      var duration = 0;
      if (start.startTime !== undefined && start.endTime !== undefined) {
        duration = start.endTime - start.startTime;
      } else if (start.startTime !== undefined && start.endTime === undefined) {
        duration = this.now - start.startTime;
      }
      start.duration = duration;
      return duration;
    },
    planeToString: function(plane) {
      var planeString = "";
      if (plane.registration !== undefined && plane.callsign !== undefined) {
        planeString = plane.callsign + " (" + plane.registration + ")";
      } else if (
        plane.registration !== undefined &&
        plane.callsign === undefined
      ) {
        planeString = plane.registration;
      }
      plane.planeString = planeString;
      return planeString;
    }
  },
  created: function() {
    this.$data.now = new moment();
    setInterval(() => {
      this.$data.now = new moment();
    }, 1000);

    var today = new moment();
    this.$data.today = today.format("YYYY-MM-DD");
    var flightsref = db.ref("flydays/" + this.$data.today + "/flights");
    flightsref.on("value", snapshot => {
      this.$data.flights = Object.entries(snapshot.val());
    });
  }
};
</script>
